import { jsx as n } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useDataGridContext as m } from "./hooks/useDataGridContext.js";
import { useRef as f, useEffect as d } from "../../../external/preact/hooks/dist/hooks.module.js";
import { isValidElement as p, cloneElement as u } from "../../../external/preact/dist/preact.module.js";
import c from "classnames";
import { CellTextPosition as s } from "./types.js";
function G({
  children: t,
  column: r,
  position: a,
  ...i
}) {
  const { registerCells: o } = m(), e = f(null);
  return d(() => {
    var l;
    e.current && o({
      column: r,
      width: (l = e.current) == null ? void 0 : l.getBoundingClientRect().width
    });
  }, [r, o]), /* @__PURE__ */ n(
    "div",
    {
      role: "cell",
      className: c("adyen-pe-data-grid__cell", {
        "adyen-pe-data-grid__cell--right": a === s.RIGHT,
        "adyen-pe-data-grid__cell--center": a === s.CENTER
      }),
      ...i,
      children: t && p(t) ? u(t, {
        ...t == null ? void 0 : t.props,
        ref: e,
        style: { width: "min-content" }
      }) : null
    }
  );
}
export {
  G as default
};
